var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let SelectInput = class SelectInput extends LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.variant = 'primary';
        this.size = 'medium';
        this.special = false;
        this.bold = false;
    }
    handleChange(e) {
        const target = e.target;
        this.value = target.value;
        this.dispatchEvent(new CustomEvent('select-change', {
            detail: { value: this.value },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        const variantClass = `select-input--${this.variant}`;
        const sizeClass = `select-input--${this.size}`;
        const specialClass = this.special ? 'select-input--special' : '';
        const boldClass = this.bold ? 'select-input--bold' : '';
        return html `
      <select
        class="select-input ${variantClass} ${sizeClass} ${specialClass} ${boldClass}"
        @change=${this.handleChange}
      >
        ${this.options.map((option) => html `<option value="${option.value}" ?selected=${option.value == this.value}>${option.label}</option>`)}
      </select>
    `;
    }
};
SelectInput.styles = css `
    .select-input {
      width: 100%;
      padding: 8px 12px;
      font-size: 14px;
      border-radius: 8px;
      border: 1px solid #ccc;
      background: #fff;
      cursor: pointer;
      transition: border 0.3s, box-shadow 0.3s, background-color 0.3s, color 0.3s;
    }

    .select-input:focus {
      border-color: #0078d4;
      box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.2);
      outline: none;
    }

    /* Variants */
    .select-input--primary {
      border-color: #0078d4;
    }

    .select-input--secondary {
      border-color: #6c757d;
    }

    .select-input--success {
      border-color: #28a745;
    }

    .select-input--danger {
      border-color: #dc3545;
    }

    .select-input--warning {
      border-color: #ffc107;
    }

    /* Sizes */
    .select-input--small {
      font-size: 12px;
      padding: 6px 10px;
    }

    .select-input--medium {
      font-size: 14px;
      padding: 8px 12px;
    }

    .select-input--large {
      height: 47px; /* Fixe la hauteur à 47px */
      font-size: 20px;
      padding: 0 14px; /* Ajuste le padding pour centrer le contenu */
    }

    /* Special styles */
    .select-input--special {
      background-color: rgba(0, 120, 212, 0.1); /* Default special background */
    }

    .select-input--special.select-input--primary {
      background-color: rgba(0, 120, 212, 0.1);
    }

    .select-input--special.select-input--secondary {
      background-color: rgba(108, 117, 125, 0.1);
    }

    .select-input--special.select-input--success {
      background-color: rgba(40, 167, 69, 0.1);
    }

    .select-input--special.select-input--danger {
      background-color: rgba(220, 53, 69, 0.1);
    }

    .select-input--special.select-input--warning {
      background-color: rgba(255, 193, 7, 0.1);
    }

    /* Bold styles */
    .select-input--bold {
      font-weight: bold;
    }

    .select-input--bold.select-input--primary {
      color: #0078d4;
    }

    .select-input--bold.select-input--secondary {
      color: #6c757d;
    }

    .select-input--bold.select-input--success {
      color: #28a745;
    }

    .select-input--bold.select-input--danger {
      color: #dc3545;
    }

    .select-input--bold.select-input--warning {
      color: #ffc107;
    }
  `;
__decorate([
    property({ type: Array })
], SelectInput.prototype, "options", void 0);
__decorate([
    property({ type: String })
], SelectInput.prototype, "value", void 0);
__decorate([
    property({ type: String })
], SelectInput.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], SelectInput.prototype, "size", void 0);
__decorate([
    property({ type: Boolean })
], SelectInput.prototype, "special", void 0);
__decorate([
    property({ type: Boolean })
], SelectInput.prototype, "bold", void 0);
SelectInput = __decorate([
    customElement('select-input')
], SelectInput);
export { SelectInput };
//# sourceMappingURL=SelectInput.js.map